var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAppVersion, getSystemType, getPlatformType, isDianpingAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from '@nibfe/mkt-env-api';
import { getLBSInfo, getLocation } from '@nibfe/mkt-lbs-api';
import { getUserInfo } from '@nibfe/mkt-user-api';
/** 获取设备信息 */
export const getCommonInfo = () => __awaiter(void 0, void 0, void 0, function* () {
    const appVersion = getAppVersion();
    const systemType = getSystemType();
    const lbsResult = yield getLBSInfo({
        needLocation: true,
        sceneToken: 'dd-000e2fca8c104839'
    });
    ;
    const { lat, lng } = yield getLocation();
    const userInfo = yield getUserInfo();
    const platformType = getPlatformType();
    const platform = isDianpingAppOrWebview() ? 2 : 1;
    console.log(appVersion, systemType, lbsResult, userInfo, lat, lng, platformType, platform, 'commonInfo');
    return {
        clientVersion: appVersion,
        osType: (systemType === null || systemType === void 0 ? void 0 : systemType.toLowerCase()) === 'ios' ? 2 : 1,
        cityId: lbsResult === null || lbsResult === void 0 ? void 0 : lbsResult.homeSelectedCity,
        locateCityId: -1,
        userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId,
        token: userInfo === null || userInfo === void 0 ? void 0 : userInfo.token,
        deviceId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid,
        clientType: 3,
        platform,
        terminalSource: isWeixinMiniProgramOrWeixinWebview() ? 5 : platform,
        lat,
        lng
    };
});
